import { Box, Typography } from '@mui/material'
import HorizontalLineChart from 'components/chart/HorizontalLineChart'
import type { CategoryStatusBreakdownDto } from 'store/dashboard'
import { STATUS_COLORS } from './chartDefaults'

interface Props {
  data: CategoryStatusBreakdownDto[]
}

const StatusByServiceTypeChart = ({ data }: Props) => {
  if (!data || data.length === 0) return null

  const legendStatuses = [...new Set(data.flatMap((d) => d.status.map((s) => s.label)))]

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {data.map((row) => (
        <Box key={row.category}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography variant='body2' sx={{ fontWeight: 600 }}>
              {row.category}
            </Typography>
            <Typography variant='body2' sx={{ fontWeight: 600 }}>
              Total: {row.total}
            </Typography>
          </Box>
          <HorizontalLineChart
            hideLegend
            showValueInBar
            minSegmentWidth={50}
            data={row.status.map((s) => ({ label: s.label, value: s.count, color: STATUS_COLORS[s.label] || '#999' }))}
          />
        </Box>
      ))}

      <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 2 }}>
        {legendStatuses.map((status) => (
          <Box key={status} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '2px',
                backgroundColor: STATUS_COLORS[status] || '#999'
              }}
            />
            <Typography variant='body2' color='gray'>
              {status}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default StatusByServiceTypeChart
